import { render, staticRenderFns } from "./course_doc.vue?vue&type=template&id=1a01e82e&scoped=true"
import script from "./course_doc.vue?vue&type=script&lang=js"
export * from "./course_doc.vue?vue&type=script&lang=js"
import style0 from "./course_doc.vue?vue&type=style&index=0&id=1a01e82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a01e82e",
  null
  
)

export default component.exports